<template>
  <div class="paging">
    <div class="paging__count">
      Viewing {{ currentVisibleItemsCount }} - {{ totalItemsCount }}
    </div>
    <button class="c-btn c-btn--padding-slim c-btn--alpha c-btn--ghost" @click="buttonClick(true)" v-if="currentPage + 1 < totalPages">
      View more
    </button>
  </div>
</template>

<script>
export default {
    props: {
        totalItemsCount: {
            type: Number,
            required: true
        },
        currentVisibleItemsCount: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    methods: {
        buttonClick(val) {
            this.$emit('loadMoreClicked', val)
        }
    }
}
</script>